export default {
  AREA_NAME: "富山県環境科学センター",
  SYSTEM_NAME: "調査データ管理システム",
  LOGOUT: "ログアウトする",
  CLOUDINFORMATION:
    "クラウドサーバーにアクセスしています…\r\nマスターデータの更新はできませんのでご注意ください",
  USER_ID: "ユーザID:",
};
